import type { ContentStep, PlanContent } from '@cfa/pathway-fe-shared/xp';

/** Flatten top-level and section steps from plan content. */
export const collectPlanSteps = (
  content: PlanContent | undefined,
): ContentStep[] => {
  if (!content) {
    return [];
  }

  const topLevelSteps = content.steps ?? [];
  const sectionSteps = (content.sections ?? []).flatMap(
    section => section.steps ?? [],
  );

  return [...topLevelSteps, ...sectionSteps];
};
